module.exports = __webpack_public_path__ + "static/media/search-employees-icon.a56c59d0.svg";